/* eslint-disable */
import * as Sentry from '@sentry/angular';
import { Capacitor } from '@capacitor/core';
import { AppVersion, BuildVersion } from '@core';
import { environment } from '../../environment/environment';
import { setSentryContext, setSentryTag } from './sentry.util';

export const initSentry = (): void => {
  if (!environment.sentryDsn) {
    return;
  }

  const platform = Capacitor.getPlatform();

  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.environment,
    release: `split-zero-web@${AppVersion}+${BuildVersion}`,

    ignoreErrors: [
      // Błędy przeglądarki/layoutu
      'ResizeObserver loop limit exceeded',
      'Non-Error promise rejection captured',

      // Błędy ładowania chunków (słabe połączenie, odświeżenie podczas deployu)
      /ChunkLoadError/i,
      /Loading chunk/i,

      // Błędy rozszerzeń przeglądarki
      /extension\//i,
      /^chrome:\/\//i,
      /^moz-extension:\/\//i,

      // Anulowanie natywnego dialogu udostępniania
      'Share canceled',

      // Google One Tap / Credential Manager - problemy po stronie urządzenia
      /failure response from one tap.*User disabled the feature/i,
      'getCredentialAsync no provider dependencies found',
      "Your device doesn't support credential manager",
      'No credentials available',

      // Błędy sieciowe (słabe połączenie użytkownika)
      /timeout of \d+ms exceeded/i,

      // Anulowanie logowania Google przez użytkownika
      /Cancelled by user/i,

      // Anulowanie aktywności logowania na Androidzie
      /activity is cancelled by the user/i,

      // Ionic - overlay już nie istnieje (timing przy nawigacji)
      'overlay does not exist',

      // Błędy wbudowanej przeglądarki Facebooka (in-app browser)
      /window\.webkit\.messageHandlers.*postMessage/i,

      // Ionicons/Stencil.js adoptedStyleSheets na Chrome < 99 (FrozenArray)
      'Cannot add property 0, object is not extensible'
    ],

    beforeBreadcrumb(breadcrumb: Sentry.Breadcrumb) {
      if (breadcrumb.category === 'console' && breadcrumb.level === 'debug') {
        return null;
      }
      return breadcrumb;
    },

    beforeSend(event: Sentry.ErrorEvent) {
      const errorMessage = event.exception?.values?.[0]?.value?.toLowerCase() ?? '';

      // HTTP status 0 - anulowane requesty, utrata sieci, przejście aplikacji do tła na iOS
      if (/http failure response for .+: 0 /.test(errorMessage)) {
        return null;
      }

      // Anulowanie logowania przez użytkownika
      if (
        errorMessage.includes('user cancelled') ||
        errorMessage.includes('user canceled') ||
        errorMessage.includes('authorizationerror error 1000') ||
        errorMessage.includes('authorizationerror error 1001')
      ) {
        return null;
      }

      return event;
    }
  });

  setSentryContext('app', {
    version: AppVersion,
    build: BuildVersion,
    platform,
    environment: environment.environment
  });

  setSentryTag('platform', platform);
  setSentryTag('appVersion', AppVersion);
  setSentryTag('build', BuildVersion);
};
